/**
 * Get a human-readable label for a tier value.
 *
 * @param tier - The tier number (0 = Tier Micro, 1-4 = Tier N, -1 = Custom, null/undefined = fallback)
 * @param fallback - What to return for null/undefined tiers (default: 'N/A')
 * @returns Human-readable tier label
 */
export function getTierLabel(
  tier?: number | null,
  fallback: string = 'N/A'
): string {
  if (tier === 0) return 'Tier Micro'
  if (tier === -1) return 'Custom'
  if (tier === null || tier === undefined) return fallback
  return `Tier ${tier}`
}

/**
 * Get tier pricing label (e.g., "Tier Micro Pricing" or "Tier pricing" for null).
 */
export function getTierPricingLabel(tier?: number | null): string {
  const label = getTierLabel(tier, 'None')
  return label === 'None' ? 'Tier pricing' : `${label} Pricing`
}
